// extracted by mini-css-extract-plugin
export default {"container":"Authorization_container__2H5zJ","text":"Authorization_text__yEqs6"};